import React, {type ReactNode} from 'react';
import {
    BoltRounded,
    DashboardRounded,
    FactoryOutlined,
    MonetizationOnOutlined,
    OndemandVideoOutlined,
    PersonOutlined,
    ReceiptOutlined,
    Search,
    VerifiedOutlined,
} from '@mui/icons-material';

/** Ordered `resultId` prefix → icon lookup used to re-hydrate persisted recent results. */
const PREFIX_ICONS: Array<[string, ReactNode]> = [
    ['action-', <BoltRounded fontSize="small"/>],
    ['tutorial-', <OndemandVideoOutlined fontSize="small"/>],
    ['customer-', <PersonOutlined fontSize="small"/>],
    ['vendors', <FactoryOutlined fontSize="small"/>],
    ['nexus-', <Search fontSize="small"/>],
    ['lookup-', <Search fontSize="small"/>],
    ['warranty-', <VerifiedOutlined fontSize="small"/>],
    ['quotes-', <ReceiptOutlined fontSize="small"/>],
    ['sales-orders-', <ReceiptOutlined fontSize="small"/>],
    ['back-orders-', <ReceiptOutlined fontSize="small"/>],
    ['invoices-', <ReceiptOutlined fontSize="small"/>],
    ['credits-', <ReceiptOutlined fontSize="small"/>],
    ['sales-', <MonetizationOnOutlined fontSize="small"/>],
];

/** Resolves a fallback icon for a persisted recent result based on its id prefix. */
export const resolveCommandSearchResultIcon = (resultId: string): ReactNode | undefined => {
    const match = PREFIX_ICONS.find(([prefix]) => resultId.startsWith(prefix));
    return match ? match[1] : <DashboardRounded fontSize="small"/>;
};

export default resolveCommandSearchResultIcon;
